export const DISHTYPES = ["Starter", "Main", "Dessert", "Snack", "Drinks", "Side"] as const;
